<template>
  <div v-once>
    <PageSections v-bind="props" />
  </div>
</template>

<script setup>
const props = defineProps({
  pageContent: {
    required: true,
    type: Object
  }
})
</script>
